function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es.function.name";
import "core-js/modules/es.parse-float";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
var floatRegexp = '[-+]?[0-9]*.?[0-9]+';
var types = [{
  name: 'px',
  regexp: new RegExp("^".concat(floatRegexp, "px$"))
}, {
  name: '%',
  regexp: new RegExp("^".concat(floatRegexp, "%$"))
},
/**
 * Fallback optopn
 * If no suffix specified, assigning "px"
 */
{
  name: 'px',
  regexp: new RegExp("^".concat(floatRegexp, "$"))
}];

var getType = function getType(value) {
  if (value === 'auto') {
    return {
      type: value,
      value: 0
    };
  }

  for (var i = 0; i < types.length; i++) {
    var type = types[i];

    if (type.regexp.test(value)) {
      return {
        type: type.name,
        value: parseFloat(value)
      };
    }
  }

  return {
    type: '',
    value: value
  };
};

export var parse = function parse(value) {
  switch (_typeof(value)) {
    case 'number':
      return {
        type: 'px',
        value: value
      };

    case 'string':
      return getType(value);

    default:
      return {
        type: '',
        value: value
      };
  }
};
export default parse;